<template>
  <div name="Sidebar">
    <div class="sidebar">
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-collapse-transition>
          <!-- 菜单---start -->
          <div class="side_ul">
            <!-- 第一级菜单---start -->
            <div
              v-for="(item, index) in menuList"
              :key="item.name"
              class="side_li"
            >
              <router-link
                v-if="!item.children || item.children.length === 0"
                tag="div"
                :to="{ name: item.name }"
                class="pacity cursor-pointer"
                :class="[
                  item.children && item.children.length > 0
                    ? 'pacityChild'
                    : '',
                  item.children && item.meta.show ? 'pacitys' : '',
                ]"
                active-class="active-menu"
                exact
                @click.native="handleMenuClick()"
              >
                <svg-icon :icon-class="item.meta.icon?item.meta.icon:''" class-name="icon" />
                <div class="name">
                  {{ generateLanguageFn(item.meta.title) }}
                </div>
              </router-link>
              <div
                v-else
                class="pacity pacityChild cursor-pointer"
                :class="[item.meta.show ? 'pacitys' : '']"
                @click="
                  updateAssignMenuShowStatus({
                    key: index,
                    showStatus: !item.meta.show,
                  })
                "
              >
                <svg-icon :icon-class="item.meta.icon?item.meta.icon:''" class-name="icon" />
                <div class="name">
                  {{ generateLanguageFn(item.meta.title) }}
                </div>
              </div>
              <!-- 第二级菜单---start -->
              <el-collapse-transition>
                <div
                  v-if="item.children && item.children.length > 0"
                  v-show="item.meta.show"
                  class="side_ul child_ul"
                >
                  <router-link
                    v-for="v in item.children"
                    :key="v.name"
                    tag="div"
                    :to="{ name: v.name }"
                    class="side_li cursor-pointer"
                    active-class="active-menu"
                    exact
                    @click.native="handleMenuClick(v)"
                  >
                    <div class="pacity">
                      <svg-icon :icon-class="v.meta.icon?v.meta.icon:''" />
                      <div class="name">
                        {{ generateLanguageFn(v.meta.title) }}
                      </div>
                    </div>
                  </router-link>
                </div>
              </el-collapse-transition>
              <!-- 第二级菜单---end -->
            </div>
            <!-- 第一级菜单---end -->
          </div>
          <!-- 菜单---end -->
        </el-collapse-transition>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { generateLanguage } from '@/utils/i18n'
export default {
  name: "Sidebar",
  /**
   * @params menuList 菜单列表
   */
  props:{
    menuList:{
      type:Array||Object,
      default:()=>{
        return [];
      },
      required:true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("width", {
      theCurrentWidth: "theCurrentWidth",
    }),
    ...mapGetters("admin/dashboard", {
      equipmentInfo: "getEquipmentInfo",
    }),
  },
  methods: {
    ...mapMutations("admin/permission", ["updateAssignMenuShowStatus"]),
    handleMenuClick() {
      if (this.theCurrentWidth < 1200) {
        this.setAdminSidebarShow(false);
      }
    },
    ...mapMutations("admin", {
      setAdminSidebarShow: "setAdminSidebarShow",
    }),
    generateLanguageFn(title){
      return generateLanguage(title)
    }
  },
};
</script>

<style lang="scss" scoped>
.active-menu {
  background: #0a1927;
  color: #FFFFFF;
}
.scrollbar-wrapper {
  height: calc(100vh - 60px);
  overflow-x: hidden !important;
}
.sidebar {
  width: 300px;
  height: calc(100vh);
}
.el-scrollbar {
  width: 100%;
  height: calc(100vh - 60px);
  background-color: #142433;
  user-select: none;
}
.select_deviceLink {
  display: block;
  background-color: #252c2e;
  padding: 17px 20px 17px 30px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #fff;
}
.btn_dropdown {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .icon {
    width: 16px;
    height: 16px;
  }
  .name {
    margin-left: 16px;
  }
}
.btn_dropdown::after {
  content: "";
  display: block;
  background: url(data:image/png;base64,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)
    0 -34px no-repeat;
  position: absolute;
  top: 2px;
  right: 2px;
  width: 25px;
  height: 25px;
  color: #fff;
}

.side_ul {
  background-color: #142433;
  color: #fff;
}
.child_ul{
  background-color: #0a1927;
  color: #999999;
  .pacity{
    height:54px;
  }
}
.pacity {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 30px;
  height: 60px;
  position: relative;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  letter-spacing: 0;
  outline: none;
  transition: height 2s;
  .icon {
    display: flex;
    width: 16px;
    height: 16px;
  }
  .name {
    margin-left: 16px;
  }
}
.cursor-pointer{
  position: relative;
}
.child_ul .cursor-pointer:hover>::before{
  content:"";
  position: absolute;
  left: 0;
  width: 6px;
  height: 54px;
  background: #347AEB;
  opacity: 1;
}
.child_ul .active-menu::before {
  content:"";
  position: absolute;
  left: 0;
  width: 6px;
  height: 54px;
  background: #347AEB;
  opacity: 1;
}
.pacityChild::after {
  content: "";
  display: block;
  background: url(data:image/png;base64,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)
    0 -100px no-repeat;
  position: absolute;
  top: 18px;
  right: 21px;
  width: 24px;
  height: 24px;
  color: #fff;
}
.pacitys{
  background-color: #0a1927;
}
.pacitys::after {
  content: "";
  display: block;
  background: url(data:image/png;base64,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)
    0 -65px no-repeat;
  position: absolute;
  top: 18px;
  right: 21px;
  width: 24px;
  height: 24px;
  color: #fff;
}
.dropdown:after {
  content: "";
  display: block;
  background: url(data:image/png;base64,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)
    0 0 no-repeat;
  position: absolute;
  top: 2px;
  right: 2px;
  width: 25px;
  height: 25px;
  color: #fff;
}

.pacity:hover {
  background: #0a1927;
  color: #FFFFFF;
}

// 中型机
.el-sba {
  height: 100vh;
  width: 80px;
  z-index: 50;
  background-color: #142433;
  padding-bottom: 200px;
  overflow: hidden;
}
</style>
